"use strict";var e=require("styled-components").css`
    --chart-principal: #0075c9;
    --chart-insurance: #ffc50a;
    --chart-taxes: #ef4b5d;
    --chart-insurance-bullet: var(--chart-insurance, #0075c9);
    --chart-principal-bullet: var(--chart-principal, #ffc50a);
    --chart-taxes-bullet: var(--chart-taxes, #ef4b5d);
    position: relative;
    margin: auto;
    width: 86%;
    gap: 40px;
    & > div {
        flex: 1;
    }
    &.shader_1 {
        --chart-principal: #9c27b0;
        --chart-taxes: #673ab7;
        --chart-insurance: #3f51b5;
    }
    &.shader_2 {
        --chart-principal: #29b6f6;
        --chart-taxes: #00acc1;
        --chart-insurance: #009688;
    }
    .container_left {
        margin-bottom: 5rem;
    }
    .slider_section {
        margin-bottom: 1rem;
        .input_error {
            color: rgb(0, 117, 201);
            font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
            font-size: 12px;
        }
    }
    .input_header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 1rem;
        p {
            margin: 0;
            line-height: 1.25rem;
            font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
            font-size: ${({theme:e})=>e.typography.p.fontSize};
        }
        .info_circle_tooltip {
            svg {
                height: 17px;
                width: 17px;
                pointer-events: none;
            }
        }
        .header_section {
            display: flex;
            gap: 0.25rem;
            align-items: center;
            .DXTooltip-trigger {
                background: transparent;
                border: none;
            }
            .DXTooltip-content {
                font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
            }
        }
    }
    .slider {
        position: relative;
        .fill {
            position: absolute;
            top: 4px;
            left: 0;
            width: 100%;
            height: 9px;
            border-radius: 5px;
            z-index: 1;
            overflow: hidden;
        }
        .upper {
            height: 100%;
            width: 100%;
            background: ${({theme:e})=>e.colors.primary.default};
            transform-origin: 0 0;
            position: absolute;
            top: 0;
            left: 0;
        }
        .lower {
            height: 100%;
            width: 100%;
            background: ${({theme:e})=>e.colors.grey[300]};
        }
    }
    input[type='range'] {
        width: 100%;
        appearance: none;
        background: transparent;
        color: ${({theme:e})=>e.colors.primary.default};
        height: 9px;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &::-webkit-slider-thumb {
            position: relative;
            appearance: none;
            height: 30px;
            width: 30px;
            background: ${({theme:e})=>e.colors.common.light};
            border: solid 1px ${({theme:e})=>e.colors.primary.default};
            border-radius: 100%;
            cursor: pointer;
            transform: translate(-1.75px, -2px);
        }
        &::-moz-range-thumb {
            position: relative;
            appearance: none;
            height: 30px;
            width: 30px;
            background: ${({theme:e})=>e.colors.common.light};
            border: solid 1px ${({theme:e})=>e.colors.primary.default};
            border-radius: 100%;
            cursor: pointer;
            transform: translate(-1.75px, 0);
        }
        &:focus {
            outline: none;
        }
    }
    .field {
        background: transparent;
        outline: none;
        border-bottom: solid 1px ${({theme:e})=>e.colors.grey[300]};
        display: flex;
        flex-direction: row;
        width:27%;
        .prefix {
            margin-right: 0.25rem;
            margin-top: 0.25rem;
        }
        .suffix {
            margin-top: 0.25rem;
        }
        input {
            border: none;
            margin: 0;
            font-size: 18px;
            line-height: 1rem;
            letter-spacing: normal;
            font-family: ${({theme:e})=>e.fonts.primary.fontFamily};
            font-weight: normal;
            width: 100%;
        }
    }
    .chart_input {
        width: 100%;
    }
    .chart_container {
        .chart_container_header {
            text-align: center;
            padding-bottom: 1rem;
            border-bottom: solid 1px ${({theme:e})=>e.colors.grey[300]};
            font-family: ${({theme:e})=>e.fonts.primary.fontFamily};
            font-size: 18px;
            letter-spacing: -0.3px;
            line-height: 1rem;
            font-weight: bold;
        }
    }
    header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .chart_center {
        .calculated_total {
            font-size: 34px;
            margin: 0;
            color: ${({theme:e})=>e.colors.common.dark};
            font-family: ${({theme:e})=>e.fonts.primary.fontFamily};
            font-weight: 600;
            letter-spacing: -0.35px;
            line-height: 26px;
        }
        .per_month {
            font-size: 12px;
            margin: 7px 0;
            color: ${({theme:e})=>e.colors.grey[600]};
            text-transform: uppercase;
        }
    }
    .chart {
        width: 96px;
    }
    ul {
        list-style: none;
        margin: 2rem 0 3.5rem;
        padding: 0;
        width: 100%;
        li {
            margin: 0;
            padding: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
        }
        .color {
            width: 0.875rem;
            height: 0.875rem;
            border-radius: 100%;
            margin-right: ${({theme:e})=>e.spacing.small};
            margin-top: 0.25rem;
        }
        .legend_item {
            display: flex;
            flex-direction: row;
            p {
                font-size: ${({theme:e})=>e.typography.caption.fontSize};
                font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
                color: ${({theme:e})=>e.colors.grey[600]};
                margin: 0;
                font-weight: 100;
                letter-spacing: normal;
                line-height: ${({theme:e})=>e.typography.caption.lineHeight};
            }
        }
    }
    .value {
        font-size: 16px;
        color: ${({theme:e})=>e.colors.common.dark};
        font-weight: 800;
        margin: 0;
    }
    .disclaimer {
        font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
        font-size: ${({theme:e})=>e.typography.small.fontSize};
        line-height: ${({theme:e})=>e.typography.small.lineHeight};
        width: 100%;
    }
    @media screen and (min-width: 1024px) {
        display: flex;
        flex-direction: row;
        gap: 4rem;
        margin: 0;
        width: 100%;
        align-items: baseline;
        .container_left {
            margin-bottom: auto;
        }
        input[type='range'] {
            &::-webkit-slider-thumb {
                height: 20px;
                width: 20px;
            }
            &::-moz-range-thumb {
                height: 20px;
                width: 20px;
            }
        }
        .chart_container {
            display: grid;
            grid-template-columns: 60% auto;
            grid-template-rows: auto;
            grid-template-areas:
                'header header'
                'chart legend'
                'disclaimer disclaimer';
            .chart_container_header {
                font-size: 20px;
                letter-spacing: -0.3px;
                line-height: 24px;
                grid-area: header;
            }
            header {
                height: 300px;
                display: grid;
                padding: 20px;
            }
            .chart {
                width: 100%;
                grid-area: chart;
                grid-column: 1;
                grid-row: 1;
            }
            .chart_center {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                grid-column: 1;
                grid-row: 1;
                .per_month {
                    margin-bottom: 0;
                }
            }
            .Legend {
                margin-top: 2rem;
                grid-area: legend;
            }
            ul {
                li {
                    flex-direction: column;
                    margin-bottom: 1.25rem;
                    > p {
                        padding-left: ${({theme:e})=>e.spacing.large};
                    }
                }
            }
            pre {
                white-space: pre-wrap;
            }
            .Disclaimer {
                grid-area: disclaimer;
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
